import type { ReactNode } from 'react';

interface Props {
  icon?: ReactNode;
  title: string;
  hint?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  /** Acción secundaria como enlace de texto (p. ej. "Prueba gratis" junto a "Iniciar sesión"). */
  secondaryLabel?: string;
  onSecondary?: () => void;
  variant?: 'default' | 'error';
  children?: ReactNode;
}

/**
 * UI compacto para estados vacíos (sin resultados) o errores ligeros.
 * Pensado para meterse dentro del cuerpo del ResultsList, el drawer o
 * un overlay sobre el mapa, sin tener que duplicar layout cada vez.
 */
export function EmptyState({ icon, title, hint, actionLabel, onAction, secondaryLabel, onSecondary, variant = 'default', children }: Props) {
  return (
    <div className={`empty-state ${variant === 'error' ? 'is-error' : ''}`}>
      {icon && <div className="es-icon" aria-hidden="true">{icon}</div>}
      <div className="es-title">{title}</div>
      {hint && <div className="es-hint">{hint}</div>}
      {actionLabel && onAction && (
        <button className="es-action" onClick={onAction}>{actionLabel}</button>
      )}
      {secondaryLabel && onSecondary && (
        <button type="button" className="es-secondary" onClick={onSecondary}>{secondaryLabel}</button>
      )}
      {children}
    </div>
  );
}
